import React from 'react';
import _ from 'lodash';

import Master from '../../Components/Master';
import { ColumnHeaderCell, EditableCell, Cell, Column, Table } from "@blueprintjs/table";

import convertMinutesToString from '../../Components/convertMinutesToString';

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");


export default class TableDummy extends Master {
	state = {
		mitarbeiter: {},
		currentMitarbieter: {},
		dateArray: {},
		daysArray: {},
		dienste: [],
		kmGesamt: 0,
		copyData: [],
	};

	shouldComponentUpdate(nextProps, nextState) {
		var doReturn = false;
		if (nextProps.mitarbeiter !== nextState.mitarbeiter) {
			doReturn = true;
			this.state.mitarbeiter = nextProps.mitarbeiter;
		}
		if (nextProps.currentMitarbeiter !== nextState.currentMitarbeiter) {
			doReturn = true;
			this.state.currentMitarbeiter = nextProps.currentMitarbeiter;
		}
		if (nextProps.dateArray !== nextState.dateArray) {
			doReturn = true;
			this.state.dateArray = nextProps.dateArray;
		}
		if (nextProps.daysArray !== nextState.daysArray) {
			doReturn = true;
			this.state.daysArray = nextProps.daysArray;
		}
		if (nextProps.dienst !== nextState.dienst) {
			var days = [];
			var daysInt = [];
			this.state.dateArray.forEach((date, k) => {
				date = moment(date).format("L");
				days[date] = k;
				daysInt.push();
			});
			nextProps.dienst.forEach((dienst) => {
				var date = moment(dienst.datum).format("L");
				daysInt[days[date]] = dienst;
			});

			this.state.dienste = daysInt;
			doReturn = true;
		}
		return doReturn;
	}

	lastRow = (rowIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell />;
		}
	};

	datum_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell />;
		}
		var ext = {};
		var info = this.state.dienste[rowIndex];
		if (!info) {
			ext = { color: "#aaa" };
		}
		var value = moment(this.props.dateArray[rowIndex]).format("DD.MM");
		this.appendToCopyData(rowIndex, columnIndex, value);
		return <Cell style={{ textAlign: "center", ...ext }}>{value}</Cell>;
	};

	tag_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell />;
		}
		var ext = {};
		var info = this.state.dienste[rowIndex];
		if (!info) {
			ext = { color: "#aaa" };
		}
		this.appendToCopyData(rowIndex, columnIndex, this.props.daysArray[rowIndex]);
		return <Cell style={{ textAlign: "center", ...ext }}>{this.props.daysArray[rowIndex]}</Cell>;
	};

	paket_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell />;
		}
		var info = this.state.dienste[rowIndex];
		if (info !== undefined && info.umlaufplan.id !== undefined) {
			this.appendToCopyData(rowIndex, columnIndex, info.umlaufplan.kuerzel + " " + info.umlaufplan.name);
			return (
				<Cell>
					{info.umlaufplan.paket} {info.umlaufplan.kuerzel} {info.umlaufplan.name}
				</Cell>
			);
		}

		if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.eintritt) {
			var day = moment(this.props.currentMitarbeiter.eintritt).format("DD");
			if (day > rowIndex) {
				return <Cell></Cell>;
			}
		}

		if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.austritt) {
			var day = moment(this.props.currentMitarbeiter.austritt).format("DD");
			if (day <= rowIndex) {
				return <Cell></Cell>;
			}
		}

		if (info !== undefined && info.besonderer_dienst.id !== undefined && info.besonderer_dienst.kuerzel.toUpperCase() !== "X") {
			var value = info.besonderer_dienst.name;
			if (info.besonderer_dienst.name === "Feiertag") {
				value = info.besonderer_dienst.kuerzel.toUpperCase();
			}
			this.appendToCopyData(rowIndex, columnIndex, value);
			return <Cell>{value}</Cell>;
		}

		return <Cell style={{ color: "#aaa" }}>DF</Cell>;
	};

	eeeStyle = { textAlign: "center", justifyContent: "center", background: "#eee" };
	eeeStyleWhite = { textAlign: "center", justifyContent: "center" };

	beginn_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell style={this.eeeStyle}></Cell>;
		}
		var info = this.state.dienste[rowIndex];
		if (info === undefined || info.besonderer_dienst.kuerzel !== undefined) {
			return <Cell style={this.eeeStyle}></Cell>;
		}
		if (info !== undefined && info.umlaufplan.id !== "") {
			this.appendToCopyData(rowIndex, columnIndex, info.zeit_beginn ? info.zeit_beginn : "");
			var classes = "";
			if (info.umlaufplan) {
				if (info.zeit_beginn_raw > 0 && info.umlaufplan.start_raw !== info.zeit_beginn_raw) {
					info["zeit_beginn_overwrite"] = true;
				}
			}
			if (info !== undefined && info["zeit_beginn_overwrite"]) {
				classes = "triangle";
			}
			return (
				<EditableCell
					className={classes}
					style={this.eeeStyle}
					onConfirm={(value) => {
						var beginnRaw = this.convertStringToIntHours(value.replace(":", "", -1));
						info.zeit_beginn = convertMinutesToString(beginnRaw, true);
						info.zeit_beginn_raw = parseFloat(beginnRaw);
						info.zeit_beginn_overwrite = parseFloat(beginnRaw) > 0 ? true : false;
						this.confirm(info);
					}}
					value={info.zeit_beginn ? info.zeit_beginn : ""}
				/>
			);
		}
		return <Cell style={this.eeeStyle}></Cell>;
	};

	ende_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell style={this.eeeStyle}></Cell>;
		}
		var info = this.state.dienste[rowIndex];
		if (info !== undefined && info.umlaufplan.id !== "") {
			if (info.umlaufplan.ende_raw > 0) {
				if (info.umlaufplan.ende_raw > 1440) {
					info.umlaufplan.ende_raw = info.umlaufplan.ende_raw - 1440;
				}
				this.appendToCopyData(rowIndex, columnIndex, info.zeit_ende ? info.zeit_ende : info.umlaufplan.ende);
				var classes = "";
				console.log("info", info);
				if (info.umlaufplan) {
					if (info.zeit_ende_raw > 0 && info.umlaufplan.ende_raw !== info.zeit_ende_raw) {
						info["zeit_ende_overwrite"] = true;
					}
				}
				if (info !== undefined && info["zeit_ende_overwrite"]) {
					classes = "triangle";
				}
				return (
					<EditableCell
						className={classes}
						style={this.eeeStyle}
						onConfirm={(value) => {
							var endeRaw = this.convertStringToIntHours(value.replace(":", "", -1));
							info.zeit_ende = convertMinutesToString(endeRaw, true);
							info.zeit_ende_raw = parseFloat(endeRaw);
							info.zeit_ende_overwrite = parseFloat(endeRaw) > 0 ? true : false;
							this.confirm(info);
						}}
						value={info.zeit_ende ? info.zeit_ende : info.umlaufplan.ende}
					/>
				);
			}
		}
		return <Cell style={this.eeeStyle}></Cell>;
	};

	ez_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			var gesamt = 0;
			this.state.dienste.forEach((item) => {
				var zeit_brutto_zeit = item.umlaufplan.brutto_zeit;
				if (item.zeit_brutto_zeit) {
					zeit_brutto_zeit = item.zeit_brutto_zeit;
				}
				if (zeit_brutto_zeit > 0) {
					gesamt += zeit_brutto_zeit;
				}
			});
			var value = convertMinutesToString(gesamt);
			this.appendToCopyData(rowIndex, columnIndex, value);
			return <Cell style={{ textAlign: "center" }}>{value}</Cell>;
		}
		var info = this.state.dienste[rowIndex];
		if (info !== undefined && info.ist_kalender != true && info.umlaufplan.id !== "" && info.umlaufplan.brutto_zeit) {
			var zeit_brutto_zeit = info.umlaufplan.brutto_zeit;
			if (info.zeit_brutto_zeit) {
				zeit_brutto_zeit = info.zeit_brutto_zeit;
			}
			var value = convertMinutesToString(zeit_brutto_zeit);
			this.appendToCopyData(rowIndex, columnIndex, value);
			return <Cell style={{ textAlign: "center" }}>{value}</Cell>;
		}
		return <Cell></Cell>;
	};

	istAz_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			var gesamt = 0;
			this.state.dienste.forEach((item, k) => {
				var eintritt = "";
				var austritt = "";

				if (this.props.currentMitarbeiter) {
					if (this.props.currentMitarbeiter.eintritt) {
						eintritt = parseInt(moment(this.props.currentMitarbeiter.eintritt).format("DD"));
					}
					if (this.props.currentMitarbeiter.austritt) {
						austritt = parseInt(moment(this.props.currentMitarbeiter.austritt).format("DD"));
					}
				}

				var currentDay = parseInt(moment(item.datum).format("DD"));

				if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.eintritt && eintritt > 1 && currentDay < eintritt) {
					return;
				}

				if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.austritt && austritt < 31 && currentDay > austritt) {
					return;
				}

				var nettoZeit = item.zeit_ende_raw - item.zeit_beginn_raw;
				var pause = item.umlaufplan.pause;
				if (item.zeit_pause) {
					nettoZeit -= item.zeit_pause;
				} else {
					nettoZeit -= pause ? pause : 0;
				}

				if ((nettoZeit === 0 || nettoZeit === undefined) && item.besonderer_dienst.stunden > 0) {
					nettoZeit = parseInt(item.besonderer_dienst.stunden * 60);
				}
				if (nettoZeit > 0) {
					gesamt += nettoZeit;
				}
			});
			var value = convertMinutesToString(gesamt);
			this.appendToCopyData(rowIndex, columnIndex, value);
			return <Cell style={{ textAlign: "center" }}>{value}</Cell>;
		}

		var info = this.state.dienste[rowIndex];
		if (info !== undefined && info.besonderer_dienst.stunden) {
			var value = convertMinutesToString(info.besonderer_dienst.stunden * 60);
			this.appendToCopyData(rowIndex, columnIndex, value);
			return <Cell style={{ textAlign: "center" }}>{value}</Cell>;
		}

		if (info !== undefined && info.umlaufplan.netto_zeit) {
			var nettoZeit = info.zeit_ende_raw - info.zeit_beginn_raw;
			var pause = info.umlaufplan.pause;
			if (info.zeit_pause > 0) {
				nettoZeit -= info.zeit_pause;
			} else {
				nettoZeit -= pause ? pause : 0;
			}
			this.appendToCopyData(rowIndex, columnIndex, convertMinutesToString(nettoZeit));
			return <Cell style={{ textAlign: "center" }}>{convertMinutesToString(nettoZeit)}</Cell>;
		}

		return <Cell></Cell>;
	};

	az_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex < this.props.daysArray.length) {
			if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.eintritt) {
				var day = moment(this.props.currentMitarbeiter.eintritt).format("DD");
				if (day > rowIndex + 1) {
					return <Cell></Cell>;
				}
			}

			if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.austritt) {
				var day = moment(this.props.currentMitarbeiter.austritt).format("DD");
				if (day <= rowIndex) {
					return <Cell></Cell>;
				}
			}
		}

		if (rowIndex > this.props.daysArray.length - 1) {
			var gesamt = 0;
			this.state.dienste.forEach((item, k) => {
				var eintritt = "";
				var austritt = "";

				if (this.props.currentMitarbeiter) {
					if (this.props.currentMitarbeiter.eintritt) {
						eintritt = parseInt(moment(this.props.currentMitarbeiter.eintritt).format("DD"));
					}
					if (this.props.currentMitarbeiter.austritt) {
						austritt = parseInt(moment(this.props.currentMitarbeiter.austritt).format("DD"));
					}
				}

				var currentDay = parseInt(moment(item.datum).format("DD"));

				if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.eintritt && eintritt > 1 && currentDay < eintritt) {
					return;
				}

				if (this.props.currentMitarbeiter && this.props.currentMitarbeiter.austritt && austritt < 31 && currentDay > austritt) {
					return;
				}

				var nettoZeit = item.zeit_netto_zeit;
				if ((nettoZeit === 0 || nettoZeit === undefined) && item.besonderer_dienst.stunden > 0) {
					nettoZeit = parseInt(item.besonderer_dienst.stunden * 60);
				}
				if (nettoZeit > 0) {
					gesamt += nettoZeit;
				}
			});
			var value = convertMinutesToString(gesamt);
			this.appendToCopyData(rowIndex, columnIndex, value);
			return <Cell style={{ textAlign: "center", ...this.eeeStyle }}>{value}</Cell>;
		}
		var info = this.state.dienste[rowIndex];

		if (info !== undefined && info.besonderer_dienst.stunden) {
			var nettoZeit = info.besonderer_dienst.stunden * 60;
			this.appendToCopyData(rowIndex, columnIndex, value);
			//return <Cell style={{textAlign: "center", ...this.eeeStyle}}>{value}</Cell>
			console.log("info", info);
			if (info !== undefined && info["zeit_netto_zeit_overwrite"]) {
				classes = "triangle";
				nettoZeit = parseInt(info.zeit_netto_zeit);
			}
			if (nettoZeit < 390) {
				classes += " yellow";
			}
			return (
				<EditableCell
					className={classes}
					style={this.eeeStyle}
					onConfirm={(value) => {
						var azRaw = this.convertStringToIntHours(value.replace(":", "", -1));
						//info.zeit_netto_zeit = convertMinutesToString(azRaw)
						info.zeit_netto_zeit = parseInt(azRaw);
						info.zeit_netto_zeit_overwrite = parseInt(azRaw) > 0 ? true : false;
						this.confirm(info);
					}}
					value={convertMinutesToString(nettoZeit)}
				/>
			);
		}

		if (info !== undefined && info.umlaufplan.netto_zeit) {
			var nettoZeit = info.zeit_netto_zeit;
			this.appendToCopyData(rowIndex, columnIndex, convertMinutesToString(nettoZeit));
			var classes = "";
			if (info !== undefined && info["zeit_netto_zeit_overwrite"]) {
				classes = "triangle";
			}
			if (nettoZeit < 390) {
				classes += " yellow";
			}
			return (
				<EditableCell
					className={classes}
					style={this.eeeStyle}
					onConfirm={(value) => {
						var azRaw = this.convertStringToIntHours(value.replace(":", "", -1));
						//info.zeit_netto_zeit = convertMinutesToString(azRaw)
						info.zeit_netto_zeit = parseInt(azRaw);
						info.zeit_netto_zeit_overwrite = parseInt(azRaw) > 0 ? true : false;
						this.confirm(info);
					}}
					value={convertMinutesToString(nettoZeit)}
				/>
			);
		}

		return <Cell style={this.eeeStyle}></Cell>;
	};

	pause_cellRenderer = (rowIndex, columnIndex) => {
		var info = this.state.dienste[rowIndex];
		if (info && info.umlaufplan) {
			this.appendToCopyData(rowIndex, columnIndex, info.zeit_pause);
			var pause = info.zeit_pause;
			var classes = "";
			if (info !== undefined && info["zeit_pause_overwrite"]) {
				classes = "triangle";
			}
			return (
				<EditableCell
					className={classes}
					style={this.eeeStyle}
					onConfirm={(value) => {
						info.zeit_pause = parseInt(value);
						//info.zeit_pause_overwrite = parseInt(value) > 0 ? true : false
						info.zeit_pause_overwrite = true;
						this.confirm(info);
					}}
					value={pause === 0 || !pause ? "" : pause}
				/>
			);
		}
		return <Cell style={this.eeeStyle}></Cell>;
	};

	kz_cellRenderer = (rowIndex, columnIndex) => {
		var info = this.state.dienste[rowIndex];
		if (info) {
			this.appendToCopyData(rowIndex, columnIndex, info.zeit_kz);
			var classes = "";
			if (info !== undefined && info["zeit_kz_overwrite"]) {
				classes = "triangle";
			}
			return (
				<EditableCell
					className={classes}
					style={this.eeeStyle}
					onConfirm={(value) => {
						info.zeit_kz = value;
						info.zeit_kz_overwrite = parseInt(value) > 0 ? true : false;
						info.ok = true;
						this.confirm(info);
					}}
					value={info.zeit_kz ? info.zeit_kz : ""}
				/>
			);
		}
		return <Cell style={this.eeeStyle}></Cell>;
	};

	km_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell style={this.eeeStyle}>{this.state.kmGesamt}</Cell>;
		}
		var info = this.state.dienste[rowIndex];
		if (info) {
			this.appendToCopyData(rowIndex, columnIndex, info.zeit_km);
			var classes = "";
			if (info !== undefined && info["zeit_km_overwrite"]) {
				classes = "triangle";
			}
			return (
				<EditableCell
					className={classes}
					style={this.eeeStyle}
					onConfirm={(value) => {
						info.zeit_km = parseFloat((value + "").replace(",", ".", -1));
						info.zeit_km_overwrite = parseFloat(value) > 0 ? true : false;
						this.confirm(info);
					}}
					value={info.zeit_km && info.zeit_km > 0 ? parseFloat(info.zeit_km).toFixed(0) : ""}
				/>
			);
		}
		return <Cell style={this.eeeStyle}></Cell>;
	};

	km_fixed_cellRenderer = (rowIndex, columnIndex) => {
		if (rowIndex > this.props.daysArray.length - 1) {
			return <Cell style={{ textAlign: "center" }}>{this.state.umlaufplankmGesamt}</Cell>;
		}
		var info = this.state.dienste[rowIndex];
		if (info) {
			this.appendToCopyData(rowIndex, columnIndex, info.umlaufplan.km);
			// check if key umlaufplan exists
			if (info.umlaufplan) {
				return <Cell style={{ textAlign: "center" }}>{info.umlaufplan.km && info.umlaufplan.km > 0 ? parseFloat(info.umlaufplan.km).toFixed(0) : ""}</Cell>;
			}
            return <Cell style={{textAlign: "center"}}>{info.zeit_km && info.zeit_km > 0 ? parseFloat(info.zeit_km).toFixed(0) : ""}</Cell>;
		}
		return <Cell style={{ textAlign: "center" }}></Cell>;
	};

	t1_cellRenderer = (rowIndex, columnIndex) => {
		var info = this.state.dienste[rowIndex];
		if (info) {
			this.appendToCopyData(rowIndex, columnIndex, info.zeit_t1);
			var classes = "";
			return (
				<EditableCell
					className={classes}
					onConfirm={(value) => {
						info.zeit_t1 = value;
						this.confirm(info);
					}}
					value={info.zeit_t1 ? info.zeit_t1 : ""}
				/>
			);
		}
		return <Cell></Cell>;
	};

	t2_cellRenderer = (rowIndex, columnIndex) => {
		var info = this.state.dienste[rowIndex];
		if (info) {
			this.appendToCopyData(rowIndex, columnIndex, info.zeit_t2);
			var classes = "";
			return (
				<EditableCell
					className={classes}
					onConfirm={(value) => {
						info.zeit_t2 = value;
						this.confirm(info);
					}}
					value={info.zeit_t2 ? info.zeit_t2 : ""}
				/>
			);
		}
		return <Cell></Cell>;
	};

	handleCheckboxChange =
		(dienst) =>
		({ target }) => {
			dienst.ok = target.checked;
			this.props.saveDienst(dienst.id, dienst);
		};

	ok_cellRenderer = (rowIndex, columnIndex) => {
		var info = this.state.dienste[rowIndex];
		if (info && info.umlaufplan.id) {
			this.appendToCopyData(rowIndex, columnIndex, info.ok ? "J" : "N");
			return (
				<Cell>
					<input style={{ margin: "3px 0" }} type="checkbox" key={info.id + info.ok} defaultChecked={info.ok ? info.ok : false} onChange={this.handleCheckboxChange(info)} />
				</Cell>
			);
		}
		return <Cell></Cell>;
	};

	confirm = (dienst) => {
		this.props.saveDienst(dienst.id, dienst);
	};

	appendToCopyData = (rowIndex, columnIndex, val) => {
		if (!this.state.copyData[rowIndex]) {
			this.state.copyData[rowIndex] = [];
		}
		if (!this.state.copyData[rowIndex][columnIndex]) {
			this.state.copyData[rowIndex][columnIndex] = "";
		}
		this.state.copyData[rowIndex][columnIndex] = val;
	};

	render() {
		var { mitarbeiter, dateArray, daysArray, dienst } = this.props;

		var days = [];
		var daysInt = [];
		dateArray.forEach((date, k) => {
			date = moment(date).format("L");
			days[date] = k;
			daysInt.push();
		});

		this.state.kmGesamt = 0;
		dienst.forEach((dienst) => {
			var date = moment(dienst.datum).format("L");
			daysInt[days[date]] = dienst;
			if (dienst.zeit_km !== undefined) {
				this.state.kmGesamt += parseInt(dienst.zeit_km);
			}
		});

		this.state.umlaufplankmGesamt = 0;
		dienst.forEach((dienst) => {
			var date = moment(dienst.datum).format("L");
			daysInt[days[date]] = dienst;
			if (dienst.umlaufplan !== undefined) {
				this.state.umlaufplankmGesamt += parseInt(dienst.umlaufplan.km.toFixed(0));
			}
		});

		this.state.dienste = daysInt;

		var columnHeader = (columnIndex) => {
			var name = "";
			switch (columnIndex) {
				case 0:
					name = "Datum";
					break;
				case 1:
					name = "Tag";
					break;
				case 2:
					name = "Paket";
					break;
				case 3:
					name = "Beginn";
					break;
				case 4:
					name = "Ende";
					break;
				case 5:
					name = "EZ";
					break;
				case 6:
					name = "Pause";
					break;
				case 7:
					name = "IST AZ";
					break;
				case 8:
					name = "AZ";
					break;
				case 9:
					name = "KZ";
					break;
				case 10:
					name = "KM**";
					break;
				case 11:
					name = "KM";
					break;
				case 13:
					name = "Text Dienstbeginn";
					break;
				case 14:
					name = "Text Dienstende";
					break;
			}

			var nameRenderer = () => (
				<div style={{ textAlign: "center" }}>
					<small>{name}</small>
				</div>
			);
			return <ColumnHeaderCell enableColumnReordering={true} style={{ textAlign: "center", justifyContent: "center", fontSize: 10 }} name={"ok"} nameRenderer={nameRenderer} />;
		};

		return (
			<Table
				getCellClipboardData={this.getCellClipboardData}
				defaultColumnWidth={200}
				columnWidths={[
					53, // datum
					50, // tag
					268, // paket

					62, // beginn
					62, // ende

					62, // EZ
					62, // pause
					62, // ist az
					62, // az

					62, // KZ
					62, // KM
					62, // KM
					35, // OK

					230, // text
					230, // text
				]}
				numRows={daysArray.length + 1}
				enableFocusedCell={true}
				renderMode={"none"}
			>
				<Column columnHeaderCellRenderer={columnHeader} name="Datum" cellRenderer={this.datum_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="Tag" cellRenderer={this.tag_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="Paket" cellRenderer={this.paket_cellRenderer} />

				<Column columnHeaderCellRenderer={columnHeader} name="Beginn" cellRenderer={this.beginn_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="Ende" cellRenderer={this.ende_cellRenderer} />

				<Column columnHeaderCellRenderer={columnHeader} name="EZ" cellRenderer={this.ez_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="Pause (=>90)" cellRenderer={this.pause_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="ist AZ" cellRenderer={this.istAz_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="AZ" cellRenderer={this.az_cellRenderer} />

				<Column columnHeaderCellRenderer={columnHeader} name="KZ" cellRenderer={this.kz_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="KM" cellRenderer={this.km_fixed_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="KM" cellRenderer={this.km_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="OK" cellRenderer={this.ok_cellRenderer} />

				<Column columnHeaderCellRenderer={columnHeader} name="Text Dienstbeginn" cellRenderer={this.t1_cellRenderer} />
				<Column columnHeaderCellRenderer={columnHeader} name="Text Dienstende" cellRenderer={this.t2_cellRenderer} />
			</Table>
		);
	}
}

// KZ = Kennzeichen (Matchcode)
// KM =  (vierstellig)


// WEBPACK FOOTER //
// ./src/Routes/Monatsuebersicht/stunden.js